<template>
  <div>
    <table-items :items="stores" :restoreState="false"/>
    <div class="row pt-3">
      <div class="mt-3 color">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Pagination from "../../components/dashboard/Pagination";
import tableItems from "../../components/dashboard/MultipleStore/tableItems";
import {order_status} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart'


export default {
  name: "AllOrders",
  components: {tableItems, Pagination},
  data() {
    return {
      order_status,
    }
  },
  computed: {
    ...mapGetters({
      stores: "MultipleStore/getStores",
      paginationMeta: "MultipleStore/getMeta",
    }),
  },
  methods: {
    changePage(page) {
      this.$store.dispatch("MultipleStore/getStores", page);
    },
  },
  async mounted() {
    await this.$store.dispatch("MultipleStore/getStores")
  },
};
</script>